import type { InstrumentQueueItemContract, Locale } from "@chams-pay/contracts";
import { translate } from "@chams-pay/contracts";
import type { InstrumentAction } from "./use-operations.js";

export function instrumentTransitionCopy(
  locale: Locale,
  item: InstrumentQueueItemContract | null,
  action: InstrumentAction,
) {
  const t = (key: Parameters<typeof translate>[1]) => translate(locale, key);
  const transfer = item?.method.method === "transfer";
  const settling = action === "settle";
  const title = settling
    ? t(transfer ? "ops.settleTransferTitle" : "ops.settleChequeTitle")
    : t(transfer ? "ops.rejectTransferTitle" : "ops.rejectChequeTitle");

  return {
    title,
    subtitle: `${t(transfer ? "ops.transfer" : "ops.cheque")} · ${item?.reference ?? ""}`,
    dateLabel: settling
      ? t(transfer ? "ops.settleTransferDate" : "ops.settleChequeDate")
      : t(transfer ? "ops.rejectTransferDate" : "ops.rejectChequeDate"),
    fieldLabel: settling
      ? t(transfer ? "ops.settleTransferReference" : "ops.settleChequeReference")
      : t(transfer ? "ops.rejectTransferReason" : "ops.rejectChequeReason"),
    note: settling ? t(transfer ? "ops.settleTransferNote" : "ops.settleChequeNote") : null,
    failureTitle: settling
      ? t(transfer ? "ops.settleTransferFailed" : "ops.settleChequeFailed")
      : t(transfer ? "ops.rejectTransferFailed" : "ops.rejectChequeFailed"),
  } as const;
}
